









import Vue from 'vue';
import { ILookupType, GeneralLookupType } from '@/Stores/LookupStore';
import {Logger} from '@/Shared/Logger';

export default Vue.extend({
    name: 'GeneralLookupDropdown',
    props: {
        type: {
            type: String as () => keyof typeof GeneralLookupType,
            validator: (value: keyof typeof GeneralLookupType) => {
                if (GeneralLookupType[value] || GeneralLookupType[value] === 0) {
                    return true;
                }
                return false;
            },
        },
        value: { type: String },
        css: { type: String },
        dropdownId: { type: String },
        parentCode: { type: String, required: false },
        placeholder: { type: String, required: false }
    },
    computed: {
        filteredLookups(): { [recID: string]: ILookupType } {
            if (!this.parentCode) {
                return this.lookups;
            }

            const filteredLookups: { [recID: string]: ILookupType } = {};

            for (const key in this.lookups) {
                if (!this.lookups.hasOwnProperty(key)) {
                    continue;
                }

                const lookupType = this.lookups[key];
                if (lookupType.parentCode!.trim() === this.parentCode.trim()) {
                    filteredLookups[key] = lookupType;
                }
            }

            return filteredLookups;
        },
        sortedLookups(): ILookupType[] {
            let arr: ILookupType[];
            arr = [];

            for (const fl in this.filteredLookups) {
                if (!this.filteredLookups.hasOwnProperty(fl)) {
                    continue;
                }

                arr.push(this.filteredLookups[fl]);
            }

            return arr.sort((x, y) => (x.order ?? 0) - (y.order ?? 0));
        }
    },
    async mounted() {
        if (this.value === undefined) {
            this.selected = null;
        }
        this.lookups = await this.loadLookups();
    },
    data() {
        return {
            lookups: {} as { [code: string]: ILookupType },
            selected: this.value as (string | null),
            placeholderText: this.placeholder || this.$t('common.select') as string
        };
    },
    methods: {
        async loadLookups(): Promise<{ [recID: string]: ILookupType }> {
            const lookupType = GeneralLookupType[this.type];
            return await this.$typedStore.modules.lookupsModule.actions.getGeneralLookups({ lookupType });
        }
    },
    watch: {
        selected(selected: string) {
            this.$emit('input', selected);
        },
        parentCode() {
            this.selected = null;
        },
        lookups() {
            Logger.Log('lookups changed', this.lookups);
        },
        value(value: string) {
            this.selected = value;
        }
    },
});
